/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const resourceOption = [
  // {
  //   value: "---Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá",
  //   label: "---Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá",
  //   disabled: true,
  // },
  {
    value: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá (75%)",
    label: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá (75%)",
  },
  {
    value: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá bán trong nước (75%)",
    label: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá bán trong nước (75%)",
  },
  // {
  //   value: "---Rượu",
  //   label: "---Rượu",
  //   disabled: true,
  // },
  {
    value: "Rượu từ 20 độ trở lên",
    label: "Rượu từ 20 độ trở lên",
  },
  {
    value: "Rượu từ 20 độ trở lên nhập khẩu bán ra trong nước (65%)",
    label: "Rượu từ 20 độ trở lên nhập khẩu bán ra trong nước (65%)",
  },
];

const DVTOption = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "tấn",
    label: "Tấn",
  },
  {
    value: "lít",
    label: "Lít",
  },
  {
    value: "chai",
    label: "Chai",
  },
  {
    value: "bao",
    label: "Bao",
  },
  {
    value: "cái",
    label: "Cái",
  },
  {
    value: "chiếc",
    label: "Chiếc",
  },
  {
    value: "hộp",
    label: "Hộp",
  },
];
const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: 1,
      bg: true,
    },
    index: {
      value: "1",
      bg: false,
    },
    title: {
      type: "select",
      value: null,
      bg: false,
    },
    unit: {
      //(4)
      type: "select",
      value: 0,
      bg: false,
    },
    amountOfConsumption: {
      //(4)
      type: "input",
      value: 0,
      bg: false,
    },
    name: {
      //(5)
      type: "input",
      value: 0,
      bg: false,
    },
    DVT: {
      // (6)
      type: "select",
      value: null,
      bg: false,
    },
    quantity: {
      // (7)
      type: "input",
      value: 0,
      bg: false,
    },
    taxPaid: {
      // (8)
      type: "input",
      value: 0,
      bg: false,
    },
    gasolineRate: {
      // (9)
      type: "input",
      value: 0,
      bg: false,
    },

    InputExciseTax: {
      // thue ttdb khau tru
      type: "input",
      value: 0,
      bg: false,
    },
    otherRevenue: {
      //doanh thu khác
      type: "input",
      value: 0,
      bg: false,
    },
    taxTTDB: {
      //gia tinh thuế ttdb
      value: 0,
      bg: false,
    },
    consumptionTaxIsAlsoDeductible: {
      type: "input",
      value: 0,
      bg: false,
    },
    tax: {
      //thue suat
      value: 0,
      bg: false,
    },
    mandatoryTax: {
      // (15)
      //
      type: "input",
      value: 0,
      bg: false,
    },
    TaxIsNotDeductible: {
      // (16)
      type: "input",
      value: 0,
      bg: false,
    },
    OffsetWithSpecialConsumptionTaxAmount: {
      // (17)
      type: "input",
      value: 0,
      bg: false,
    },
    exciseTaxOnGasoline: {
      // (18)
      type: "input",
      value: 0,
      bg: false,
    },
    exciseTaxOnGasolineTotal: {
      // (19)
      type: "input",
      value: 0,
      bg: false,
    },
  },
];
export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    console.log(newIdValue);
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: newIdValue,
        bg: true,
      },
      index: {
        value: "1",
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      unit: {
        //(4)
        type: "select",
        value: 0,
        bg: false,
      },
      amountOfConsumption: {
        //(4)
        type: "input",
        value: 0,
        bg: false,
      },
      name: {
        //(5)
        type: "input",
        value: 0,
        bg: false,
      },
      DVT: {
        // (6)
        type: "select",
        value: null,
        bg: false,
      },
      quantity: {
        // (7)
        type: "input",
        value: 0,
        bg: false,
      },
      taxPaid: {
        // (8)
        type: "input",
        value: 0,
        bg: false,
      },
      gasolineRate: {
        // (9)
        type: "input",
        value: 0,
        bg: false,
      },

      InputExciseTax: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      otherRevenue: {
        //doanh thu khác
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: 0,
        bg: false,
      },
      consumptionTaxIsAlsoDeductible: {
        type: "input",
        value: 0,
        bg: false,
      },
      tax: {
        //thue suat
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // (15)
        //
        type: "input",
        value: 0,
        bg: false,
      },
      TaxIsNotDeductible: {
        // (16)
        type: "input",
        value: 0,
        bg: false,
      },
      OffsetWithSpecialConsumptionTaxAmount: {
        // (17)
        type: "input",
        value: 0,
        bg: false,
      },
      exciseTaxOnGasoline: {
        // (18)
        type: "input",
        value: 0,
        bg: false,
      },
      exciseTaxOnGasolineTotal: {
        // (19)
        type: "input",
        value: 0,
        bg: false,
      },
    };

    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Việt Nam Đồng
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", width: "50%" }} rowSpan="2">
                Tên loại hàng hóa, dịch vụ
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đơn vị tính
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số lượng tiêu thụ trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="3">
                Lượng nguyên liệu mua vào của kỳ khai thuế trước liền kề
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB đã nộp của nguyên liệu mua vào
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tỷ lệ xăng khoáng trong xăng sinh học(%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB còn được khấu trừ ký trước chuyển sang
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB đầu vào được khấu trừ tương ứng hàng hóa bán ra
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Doanh thu khác(Chưa có thuế GTGT)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Giá tính thuế TTĐB
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế suất(%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB phải nộp
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB chưa được khấu trừ trong kỳ
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Bù trừ với số thuế TTĐB phải nộp của hàng hóa, dịch vụ khác
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB của xăng khoảng đề nghị hoàn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Thuế TTĐB của xăng khoảng còn lại được khấu trừ chuyển kỳ sau
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Tên</Th>
              <Th style={{ textAlign: "center" }}>Lượng</Th>
              <Th style={{ textAlign: "center" }}>ĐVT</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)= (8)x(6)x(9)x(4)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)=(12)/[1+(14)]</Th>
              <Th style={{ textAlign: "center" }}>(14)</Th>
              <Th style={{ textAlign: "center" }}>(15)=(13)x(14)-(11)-(10)</Th>
              <Th style={{ textAlign: "center" }}>{"(16)=(13)x(14)-(11)-(10)<0"}</Th>
              <Th style={{ textAlign: "center" }}>(17)</Th>
              <Th style={{ textAlign: "center" }}>(18)</Th>
              <Th style={{ textAlign: "center" }}>(19)=(16)-(17)(18)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.id.value}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.unit.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.unit?.type !== "select" ? (
                      row.unit.value
                    ) : (
                      <SelectTable
                        name="unit"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.name.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.name?.type !== "input" ? (
                      row.name.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="name"
                        value={row.name.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxPaid?.type !== "input" ? (
                      row.taxPaid.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="taxPaid"
                        value={row.taxPaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.gasolineRate.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.gasolineRate?.type !== "input" ? (
                      row.gasolineRate.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="gasolineRate"
                        value={row.gasolineRate.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.InputExciseTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.InputExciseTax?.type !== "input" ? (
                      row.InputExciseTax.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="InputExciseTax"
                        value={row.InputExciseTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.otherRevenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.otherRevenue?.type !== "input" ? (
                      row.otherRevenue.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="otherRevenue"
                        value={row.otherRevenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.consumptionTaxIsAlsoDeductible.bg
                        ? "transparent"
                        : "#ddeff3",
                    }}
                  >
                    {row.consumptionTaxIsAlsoDeductible?.type !== "input" ? (
                      row.consumptionTaxIsAlsoDeductible.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="consumptionTaxIsAlsoDeductible"
                        value={row.consumptionTaxIsAlsoDeductible.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxIsNotDeductible.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxIsNotDeductible?.type !== "input" ? (
                      row.TaxIsNotDeductible.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="TaxIsNotDeductible"
                        value={row.TaxIsNotDeductible.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.OffsetWithSpecialConsumptionTaxAmount.bg
                        ? "transparent"
                        : "#ddeff3",
                    }}
                  >
                    {row.OffsetWithSpecialConsumptionTaxAmount?.type !== "input" ? (
                      row.OffsetWithSpecialConsumptionTaxAmount.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="OffsetWithSpecialConsumptionTaxAmount"
                        value={row.OffsetWithSpecialConsumptionTaxAmount.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.exciseTaxOnGasoline.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.exciseTaxOnGasoline?.type !== "input" ? (
                      row.exciseTaxOnGasoline.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="exciseTaxOnGasoline"
                        value={row.exciseTaxOnGasoline.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.exciseTaxOnGasolineTotal.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.exciseTaxOnGasolineTotal?.type !== "input" ? (
                      row.exciseTaxOnGasolineTotal.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="exciseTaxOnGasolineTotal"
                        value={row.exciseTaxOnGasolineTotal.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
